class NotxsVideoBubble extends HTMLElement {
  connectedCallback() {
    /* =====================================================
       ELEMENTOS PRINCIPAIS
    ===================================================== */

    this.dialog = this.querySelector('[data-notxs-bubble-dialog]');
    this.openButton = this.querySelector('[data-notxs-bubble-open]');
    this.closeButton = this.querySelector('[data-notxs-bubble-close]');

    /*
      Vídeo pequeno do bubble
    */
    this.previewVideo =
      this.openButton?.querySelector('video') || null;

    /*
      Vídeo principal dentro da janela/modal
    */
    this.modalVideo =
      this.querySelector('.notxs-video-bubble__modal-media video') ||
      this.dialog?.querySelector('video') ||
      null;


    /* =====================================================
       CONFIGURA O VÍDEO PEQUENO
    ===================================================== */

    if (this.previewVideo) {
      this.previewVideo.muted = true;
      this.previewVideo.defaultMuted = true;
      this.previewVideo.autoplay = true;
      this.previewVideo.loop = true;
      this.previewVideo.playsInline = true;

      this.previewVideo.setAttribute('muted', '');
      this.previewVideo.setAttribute('autoplay', '');
      this.previewVideo.setAttribute('loop', '');
      this.previewVideo.setAttribute('playsinline', '');
      this.previewVideo.setAttribute('preload', 'metadata');

      this.playPreviewVideo();
    }


    /* =====================================================
       CONFIGURA O VÍDEO DO MODAL
    ===================================================== */

    if (this.modalVideo) {
      /*
        MUTED é importante para garantir autoplay
        no Chrome, Safari, iPhone e Android.
      */
      this.modalVideo.muted = true;
      this.modalVideo.defaultMuted = true;

      this.modalVideo.autoplay = true;
      this.modalVideo.playsInline = true;
      this.modalVideo.preload = 'auto';

      this.modalVideo.setAttribute('muted', '');
      this.modalVideo.setAttribute('autoplay', '');
      this.modalVideo.setAttribute('playsinline', '');
      this.modalVideo.setAttribute('preload', 'auto');
    }


    /* =====================================================
       ABRIR MODAL
    ===================================================== */

    this.openButton?.addEventListener('click', () => {
      this.open();
    });


    /* =====================================================
       FECHAR PELO X
    ===================================================== */

    this.closeButton?.addEventListener('click', () => {
      this.close();
    });


    /* =====================================================
       FECHAR CLICANDO FORA DO MODAL
    ===================================================== */

    this.dialog?.addEventListener('click', (event) => {
      if (event.target === this.dialog) {
        this.close();
      }
    });


    /* =====================================================
       QUANDO O DIALOG É FECHADO
       Inclui fechamento pelo ESC
    ===================================================== */

    this.dialog?.addEventListener('close', () => {
      this.stopModalVideo();
      this.playPreviewVideo();
    });


    /* =====================================================
       ESC
    ===================================================== */

    this.dialog?.addEventListener('cancel', () => {
      this.stopModalVideo();
      this.playPreviewVideo();
    });


    /* =====================================================
       FORMULÁRIOS DE PRODUTO
    ===================================================== */

    this.querySelectorAll('[data-notxs-product-form]').forEach((form) => {
      if (window.bindNotxsProductForm) {
        window.bindNotxsProductForm(form);
      } else {
        bindBubbleProductForm(form);
      }
    });
  }


  /* =======================================================
     ABRIR JANELA
  ======================================================= */

  open() {
    if (!this.dialog) return;


    /*
      Pausa o vídeo pequeno enquanto
      o vídeo principal estiver aberto.
    */
    this.pausePreviewVideo();


    /*
      Abre o dialog.
    */
    if (typeof this.dialog.showModal === 'function') {
      if (!this.dialog.open) {
        this.dialog.showModal();
      }
    } else {
      this.dialog.setAttribute('open', '');
    }


    /*
      Executa autoplay imediatamente.
    */
    this.playModalVideo();


    /*
      Segunda tentativa logo após o navegador
      renderizar o modal.

      Isso resolve casos onde o vídeo estava
      display:none / invisível antes do showModal().
    */
    requestAnimationFrame(() => {
      this.playModalVideo();
    });
  }


  /* =======================================================
     FECHAR JANELA
  ======================================================= */

  close() {
    if (!this.dialog) return;


    /*
      Para o vídeo antes de fechar.
    */
    this.stopModalVideo();


    /*
      Fecha dialog nativo.
    */
    if (
      typeof this.dialog.close === 'function' &&
      this.dialog.open
    ) {
      this.dialog.close();
    } else {
      this.dialog.removeAttribute('open');

      /*
        Se não for dialog nativo,
        precisamos reativar manualmente o preview.
      */
      this.playPreviewVideo();
    }
  }


  /* =======================================================
     AUTOPLAY DO VÍDEO PRINCIPAL
  ======================================================= */

  playModalVideo() {
    const video = this.modalVideo;

    if (!video) return;


    /* -----------------------------------------------------
       GARANTE CONFIGURAÇÕES NECESSÁRIAS PARA AUTOPLAY
    ----------------------------------------------------- */

    video.muted = true;
    video.defaultMuted = true;

    video.autoplay = true;
    video.playsInline = true;
    video.preload = 'auto';

    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('preload', 'auto');


    /* -----------------------------------------------------
       RECOMEÇA DO INÍCIO
    ----------------------------------------------------- */

    try {
      video.currentTime = 0;
    } catch (error) {
      /*
        Alguns navegadores podem bloquear currentTime
        antes dos metadados estarem disponíveis.
      */
    }


    /* -----------------------------------------------------
       TENTA REPRODUZIR
    ----------------------------------------------------- */

    const tryPlay = () => {
      const playPromise = video.play();

      if (
        playPromise &&
        typeof playPromise.catch === 'function'
      ) {
        playPromise.catch(() => {
          /*
            Se ainda não estiver pronto,
            aguardamos o vídeo ficar reproduzível.
          */
        });
      }
    };


    /*
      Se o navegador já possui dados suficientes,
      toca imediatamente.
    */
    if (video.readyState >= 2) {
      tryPlay();
      return;
    }


    /*
      Primeira tentativa mesmo antes do canplay.
      Muitos navegadores já iniciam o carregamento
      automaticamente.
    */
    tryPlay();


    /*
      Se ainda não estiver pronto,
      aguarda canplay e executa novamente.

      { once: true } evita acumular eventos
      toda vez que o modal for aberto.
    */
    video.addEventListener(
      'canplay',
      () => {
        tryPlay();
      },
      { once: true }
    );
  }


  /* =======================================================
     PARAR VÍDEO PRINCIPAL
  ======================================================= */

  stopModalVideo() {
    const video = this.modalVideo;

    if (!video) return;


    video.pause();


    /*
      Volta para o início para que,
      na próxima abertura, o vídeo comece novamente.
    */
    try {
      video.currentTime = 0;
    } catch (error) {
      /*
        Ignora caso metadata ainda não esteja disponível.
      */
    }
  }


  /* =======================================================
     PLAY DO VÍDEO PEQUENO
  ======================================================= */

  playPreviewVideo() {
    const video = this.previewVideo;

    if (!video) return;


    video.muted = true;
    video.defaultMuted = true;

    video.autoplay = true;
    video.loop = true;
    video.playsInline = true;

    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');


    const playPromise = video.play();

    if (
      playPromise &&
      typeof playPromise.catch === 'function'
    ) {
      playPromise.catch(() => {});
    }
  }


  /* =======================================================
     PAUSAR VÍDEO PEQUENO
  ======================================================= */

  pausePreviewVideo() {
    if (!this.previewVideo) return;

    this.previewVideo.pause();
  }
}



/* =========================================================
   FORMULÁRIO DO PRODUTO
========================================================= */

function bindBubbleProductForm(form) {
  if (form.dataset.notxsBound === 'true') return;

  form.dataset.notxsBound = 'true';


  const select =
    form.querySelector('[data-notxs-variant-select]');

  const price =
    form.querySelector('[data-notxs-price]');

  const message =
    form.querySelector('[data-notxs-form-message]');


  /* =======================================================
     ALTERAÇÃO DE VARIANTE
  ======================================================= */

  if (select && price) {
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];

      if (option?.dataset.price) {
        price.textContent = option.dataset.price;
      }
    });
  }


  /* =======================================================
     SUBMIT DO PRODUTO
  ======================================================= */

  form.addEventListener('submit', async (event) => {
    event.preventDefault();


    const action =
      form.dataset.actionMode || 'cart';


    const variantField =
      form.querySelector('[data-notxs-variant-id]');


    const variantId =
      variantField?.value;


    const submit =
      form.querySelector('[data-notxs-submit]');


    /* =====================================================
       REDIRECIONAR PARA PRODUTO
    ===================================================== */

    if (action === 'product') {
      window.location.href =
        form.dataset.productUrl || '/';

      return;
    }


    /* =====================================================
       SEM VARIANTE
    ===================================================== */

    if (!variantId) {
      if (message) {
        message.textContent =
          'Selecione uma opção.';
      }

      return;
    }


    if (submit) {
      submit.disabled = true;
    }


    if (message) {
      message.textContent = '';
    }


    /* =====================================================
       CONFIGURAÇÕES SHOPIFY / MINIMOG
    ===================================================== */

    const settings =
      window.MinimogSettings || {};


    const addUrl =
      (
        settings.routes &&
        settings.routes.cart_add_url
      ) ||
      '/cart/add.js';


    const cartDrawer =
      document.querySelector('m-cart-drawer');


    const useDrawer =
      Boolean(
        cartDrawer &&
        settings.enable_cart_drawer
      );


    /* =====================================================
       BODY
    ===================================================== */

    const body = {
      id: Number(variantId),
      quantity: 1
    };


    /* =====================================================
       SEÇÕES DO CART DRAWER
    ===================================================== */

    if (
      useDrawer &&
      typeof cartDrawer.getSectionsToRender === 'function'
    ) {
      body.sections =
        cartDrawer
          .getSectionsToRender()
          .map((section) => section.id)
          .join(',');

      body.sections_url =
        window.location.pathname;
    }


    /* =====================================================
       ADICIONAR AO CARRINHO
    ===================================================== */

    try {
      const response =
        await fetch(addUrl, {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },

          body: JSON.stringify(body)
        });


      const addedItem =
        await response
          .json()
          .catch(() => ({}));


      /* ===================================================
         ERRO
      =================================================== */

      if (
        addedItem.status ||
        !response.ok
      ) {
        throw new Error(
          addedItem.description ||
          addedItem.message ||
          'cart_error'
        );
      }


      /* ===================================================
         CHECKOUT
      =================================================== */

      if (action === 'checkout') {
        window.location.href = '/checkout';
        return;
      }


      /* ===================================================
         MENSAGEM
      =================================================== */

      if (message) {
        message.textContent =
          'Produto adicionado ao carrinho.';
      }


      /* ===================================================
         ABRIR CART DRAWER
      =================================================== */

      if (
        typeof window.notxsOpenCartDrawer === 'function'
      ) {
        window.notxsOpenCartDrawer(
          cartDrawer,
          addedItem
        );
      } else if (
        cartDrawer &&
        typeof cartDrawer.onCartDrawerUpdate === 'function'
      ) {
        cartDrawer.onCartDrawerUpdate();
        cartDrawer.open();
      }


      /* ===================================================
         EVENTOS DO MINIMOG
      =================================================== */

      if (
        window.MinimogEvents &&
        window.MinimogTheme &&
        window.MinimogTheme.pubSubEvents
      ) {
        window.MinimogEvents.emit(
          window.MinimogTheme.pubSubEvents.cartUpdate,
          addedItem
        );

        window.MinimogEvents.emit(
          window.MinimogTheme.pubSubEvents.openCartDrawer
        );
      }


      /* ===================================================
         EVENTOS PERSONALIZADOS
      =================================================== */

      document.dispatchEvent(
        new CustomEvent(
          'cart:updated',
          {
            detail: {
              item: addedItem
            }
          }
        )
      );


      document.dispatchEvent(
        new CustomEvent(
          'notxs:cart-added'
        )
      );


    } catch (error) {


      if (message) {
        message.textContent =
          'Não foi possível adicionar agora.';
      }


    } finally {


      if (submit) {
        submit.disabled = false;
      }


    }
  });
}



/* =========================================================
   REGISTRA O CUSTOM ELEMENT
========================================================= */

if (
  !customElements.get('notxs-video-bubble')
) {
  customElements.define(
    'notxs-video-bubble',
    NotxsVideoBubble
  );
}